import { Plus } from "lucide-react";
import { useTranslate } from "ra-core";
import { useState } from "react";
import { useMatch } from "react-router";
import { ContactCreateSheet } from "@/components/atomic-crm/contacts/ContactCreateSheet";
import { NoteCreateSheet } from "@/components/atomic-crm/notes/NoteCreateSheet";
import { TaskCreateSheet } from "@/components/atomic-crm/tasks/TaskCreateSheet";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

/** Mobile quick-create (contact, note, task), same sheets as upstream MobileNavigation. */
export const MobileCreateButton = () => {
  const translate = useTranslate();
  const contactId = useMatch("/contacts/:id/*")?.params.id;
  const [contactOpen, setContactOpen] = useState(false);
  const [noteOpen, setNoteOpen] = useState(false);
  const [taskOpen, setTaskOpen] = useState(false);
  return (
    <>
      <ContactCreateSheet open={contactOpen} onOpenChange={setContactOpen} />
      <NoteCreateSheet
        open={noteOpen}
        onOpenChange={setNoteOpen}
        contact_id={contactId}
      />
      <TaskCreateSheet
        open={taskOpen}
        onOpenChange={setTaskOpen}
        contact_id={contactId}
      />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            size="icon"
            className="-mt-4 size-12 shrink-0 self-center rounded-full"
            aria-label={translate("ra.action.create")}
          >
            <Plus className="size-6" aria-hidden="true" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem
            className="h-12 px-4 text-base"
            onSelect={() => setContactOpen(true)}
          >
            {translate("resources.contacts.forcedCaseName")}
          </DropdownMenuItem>
          <DropdownMenuItem
            className="h-12 px-4 text-base"
            onSelect={() => setNoteOpen(true)}
          >
            {translate("resources.notes.forcedCaseName")}
          </DropdownMenuItem>
          <DropdownMenuItem
            className="h-12 px-4 text-base"
            onSelect={() => setTaskOpen(true)}
          >
            {translate("resources.tasks.forcedCaseName")}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
